module.exports = __webpack_public_path__ + "static/media/W18-0610_AW_SpicyGuac_LTO_Burger_Lineup_mobile_hero_767x845_FR.0979164c.jpg";